// apps/client/src/ui/kit/Scrim.tsx
export function Scrim(p: { onClick?: () => void }) { return <div className="scrim hit" onClick={p.onClick} />; }
